<template>
  <v-card max-width="500" class="mx-auto elevation-0" color="transparent">
    <v-card-title
      class="justify-center"
    >
      <v-img
        :src="require('@/assets/undraw_delivery_address_03n0.svg')"
        height="100"
        contain
      ></v-img>
      Adresse
    </v-card-title>

    <v-form ref="addressForm" @submit.prevent>
      <v-expansion-panels v-model="activePanelIndex" :readonly="isSaving">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <template v-slot:default="{ open }">
              <v-row no-gutters>
                <v-col cols="4">
                  Adresse
                </v-col>
                <v-col
                  cols="8"
                  class="text--secondary"
                >
                  <v-fade-transition leave-absolute>
                    <span
                      v-if="open"
                      key="0"
                    >
                      Modifiez votre adresse
                    </span>
                    <span
                      v-else
                      key="1"
                    >
                      {{ user.address.streetAndNumber }}
                    </span>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row no-gutters>
              <v-col cols="12" sm="8" offset-sm="4">
                <v-text-field
                  label="Adresse"
                  v-model="streetAndNumber"
                  :rules="rules.streetAndNumber"
                  validate-on-blur
                  filled
                  :disabled="isSaving"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="secondary"
                :disabled="isSaving"
                @click="close"
              >
                Annuler
              </v-btn>
              <v-btn
                text
                color="primary"
                :loading="isSaving"
                @click="modify({ adresse: streetAndNumber })"
              >
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header v-slot="{ open }">
            <v-row no-gutters>
              <v-col cols="4">
                Ville
              </v-col>
              <v-col
                cols="8"
                class="text--secondary"
              >
                <v-fade-transition leave-absolute>
                  <span
                    v-if="open"
                    key="0"
                  >
                    Modifiez votre ville
                  </span>
                  <span
                    v-else
                    key="1"
                  >
                    {{ user.address.zipCode }} - {{ user.address.city }}
                  </span>
                </v-fade-transition>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row no-gutters>
              <v-col cols="12" sm="8" offset-sm="4">
                <v-text-field
                  label="Code Postal"
                  v-model="zipCode"
                  :rules="rules.zipCode"
                  validate-on-blur
                  filled
                  :disabled="isSaving"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="8" offset-sm="4">
                <v-text-field
                  label="Ville"
                  v-model="city"
                  :rules="rules.city"
                  validate-on-blur
                  filled
                  :disabled="isSaving"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="secondary"
                :disabled="isSaving"
                @click="close"
              >
                Annuler
              </v-btn>
              <v-btn
                text
                color="primary"
                :loading="isSaving"
                @click="modify({ code_postal: zipCode, ville: city })"
              >
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header v-slot="{ open }">
            <v-row no-gutters>
              <v-col cols="4">
                Pays
              </v-col>
              <v-col
                cols="8"
                class="text--secondary"
              >
                <v-fade-transition leave-absolute>
                  <span
                    v-if="open"
                    key="0"
                  >
                    Modifiez votre pays
                  </span>
                  <span
                    v-else
                    key="1"
                  >
                    {{ user.address.country }}
                  </span>
                </v-fade-transition>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row no-gutters>
              <v-col cols="12" sm="8" offset-sm="4">
                <v-autocomplete
                  label="Pays"
                  v-model="country"
                  :items="countries"
                  item-text="country_name"
                  item-value="country_name"
                  :rules="rules.country"
                  validate-on-blur
                  filled
                  :disabled="isSaving"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="secondary"
                :disabled="isSaving"
                @click="close"
              >
                Annuler
              </v-btn>
              <v-btn
                text
                color="primary"
                :loading="isSaving"
                @click="modify({ pays: country })"
              >
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-form>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import rulesMixin from '@/mixins/rulesMixin';

export default {
  name: 'ProfileAddress',

  mixins: [rulesMixin],

  props: {
    countries: Array,
  },

  data: () => ({
    streetAndNumber: '',
    zipCode: '',
    city: '',
    country: '',
    activePanelIndex: undefined,
    isSaving: false,
  }),

  computed: {
    ...mapState(['user']),
  },

  methods: {
    ...mapActions(['updateUserData']),

    close() {
      this.activePanelIndex = undefined;
    },

    modify(data) {
      if (!this.$refs.addressForm.validate()) return;
      this.isSaving = true;
      this.updateUserData(data)
        .then(() => {
          this.close();
        })
        .catch(() => {
          this.$store.commit('SET_SNACKBAR', {
            isActive: true,
            text: 'Erreur lors de la modification du profil',
          });
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },

  watch: {
    activePanelIndex() {
      this.streetAndNumber = this.user.address.streetAndNumber;
      this.zipCode = this.user.address.zipCode;
      this.city = this.user.address.city;
      this.country = this.user.address.country;
      this.$refs.addressForm.resetValidation();
    },
  },
};
</script>
